import type { ReactNode } from "react";
import { Route } from "react-router";
import { RequireAdmin } from "@/components/gavion/settings/users/RequireAdmin";
import { lazyNamed } from "../routes/lazyNamed";
import { EmailIndexRedirect } from "./EmailIndexRedirect";
import { EmailShell } from "./EmailShell";

// Quality pass: the email pages (and the rich-text editor they use) load when the section opens.
const EmailAttentionPage = lazyNamed(
  () => import("./attention/EmailAttentionPage"),
  "EmailAttentionPage",
); // GAVION A12
const CampaignReportPage = lazyNamed(
  () => import("./campaigns/CampaignReportPage"),
  "CampaignReportPage",
);
const CampaignsPage = lazyNamed(
  () => import("./campaigns/CampaignsPage"),
  "CampaignsPage",
);
const CampaignWizardPage = lazyNamed(
  () => import("./campaigns/CampaignWizardPage"),
  "CampaignWizardPage",
);
const SegmentEditPage = lazyNamed(
  () => import("./segments/SegmentEditPage"),
  "SegmentEditPage",
);
const SegmentsPage = lazyNamed(
  () => import("./segments/SegmentsPage"),
  "SegmentsPage",
);
const SequenceEditPage = lazyNamed(
  () => import("./sequences/SequenceEditPage"),
  "SequenceEditPage",
);
const SequencesPage = lazyNamed(
  () => import("./sequences/SequencesPage"),
  "SequencesPage",
);
const StopRequestsPage = lazyNamed(
  () => import("./stopRequests/StopRequestsPage"),
  "StopRequestsPage",
);
const TemplateEditPage = lazyNamed(
  () => import("./templates/TemplateEditPage"),
  "TemplateEditPage",
);
const TemplatesPage = lazyNamed(
  () => import("./templates/TemplatesPage"),
  "TemplatesPage",
);

const admin = (page: ReactNode) => <RequireAdmin>{page}</RequireAdmin>;

/**
 * Email section (spec 08), mounted in CRM.tsx <CustomRoutes> for desktop and mobile.
 * `campagnes/:id` shows the report; the wave-D page opens the wizard for drafts.
 * Static segments (`nouveau`, `nouvelle`) outrank `:id` in react-router ranking.
 */
export const emailRoutes = (
  <Route path="/courriels" element={<EmailShell />}>
    <Route index element={<EmailIndexRedirect />} />
    {/* GAVION rep-missed-call: reps see and edit the two « Appel manqué » templates only (pages check the role) */}
    <Route path="modeles" element={<TemplatesPage />} />
    <Route path="modeles/nouveau" element={admin(<TemplateEditPage />)} />
    <Route path="modeles/:id" element={<TemplateEditPage />} />
    <Route path="segments" element={admin(<SegmentsPage />)} />
    <Route path="segments/nouveau" element={admin(<SegmentEditPage />)} />
    <Route path="segments/:id" element={admin(<SegmentEditPage />)} />
    <Route path="campagnes" element={admin(<CampaignsPage />)} />
    <Route path="campagnes/nouvelle" element={admin(<CampaignWizardPage />)} />
    <Route path="campagnes/:id" element={admin(<CampaignReportPage />)} />
    <Route path="sequences" element={<SequencesPage />} />
    <Route path="sequences/nouvelle" element={admin(<SequenceEditPage />)} />
    <Route path="sequences/:id" element={<SequenceEditPage />} />
    <Route path="demandes-arret" element={admin(<StopRequestsPage />)} />
    {/* GAVION A12: sends on hold or to check */}
    <Route path="a-verifier" element={admin(<EmailAttentionPage />)} />
  </Route>
);
